import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Contato from "./Components/Contato";
import Header from "./Components/Header";
import Produtos from "./Components/Produtos";
import Footer from "./Components/Footer";
import Produto from "./Components/Produto";
import Pag404 from "./Components/Pag404.js";

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <div className="content">
          <Routes>
            <Route path="Ranek-Produtos" element={<Produtos />} />
            <Route path="Ranek-Produtos/produto/:id" element={<Produto />} />
            <Route path="contato" element={<Contato />} />
            <Route path="*" element={<Pag404 />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;
